const handleReopenActionFormActions = {
  confirm: 'Deseja realmente reabrir essa ação?',
  title: 'REABRIR AÇÃO',
  newStatus: 'Em Andamento'
};

export default handleReopenActionFormActions;
